module.exports = __webpack_public_path__ + "img/jpg.cb510005.svg";